import {
  FaArrowLeft,
  FaRegCalendarAlt,
  FaRegFileAlt,
  FaUserCircle,
  FaPlayCircle,
} from "react-icons/fa";
import { CiStar } from "react-icons/ci";
import {
  MdCheckCircle,
  MdKeyboardArrowDown,
  MdRadioButtonUnchecked,
} from "react-icons/md";
import { MdOutlineFormatListBulleted } from "react-icons/md";
import { FaRegClock } from "react-icons/fa";
import { IoCheckmarkCircleOutline, IoChevronForward } from "react-icons/io5";
import { CiLink } from "react-icons/ci";
import { FiArrowRight } from "react-icons/fi";
import { BiMoviePlay } from "react-icons/bi";
import { IoIosGlobe } from "react-icons/io";
import { GrDocumentPdf } from "react-icons/gr";
import { SlRefresh } from "react-icons/sl";
import { IoMdCalendar } from "react-icons/io";
import { CiFilter } from "react-icons/ci";
import { BiSave } from "react-icons/bi";
import { IoArrowBack } from "react-icons/io5";
import { IoCloseOutline } from "react-icons/io5";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";

export let globalIcons = {
  Link: CiLink as React.FC<React.SVGProps<SVGSVGElement>>,
  ListIcon: MdOutlineFormatListBulleted as React.FC<
    React.SVGProps<SVGSVGElement>
  >,
  MediaPlayer: FaPlayCircle as React.FC<React.SVGProps<SVGSVGElement>>,
  ArrowLeft: FaArrowLeft as React.FC<React.SVGProps<SVGSVGElement>>,
  DownArrow: MdKeyboardArrowDown as React.FC<React.SVGProps<SVGSVGElement>>,
  Star: CiStar as React.FC<React.SVGProps<SVGSVGElement>>,
  CalenderIcon: FaRegCalendarAlt as React.FC<React.SVGProps<SVGSVGElement>>,
  FileIcon: FaRegFileAlt as React.FC<React.SVGProps<SVGSVGElement>>,
  CheckIcon: MdCheckCircle as React.FC<React.SVGProps<SVGSVGElement>>,
  UncheckIcon: MdRadioButtonUnchecked as React.FC<
    React.SVGProps<SVGSVGElement>
  >,
  ProfileIcon: FaUserCircle as React.FC<React.SVGProps<SVGSVGElement>>,
  ClockIcon: FaRegClock as React.FC<React.SVGProps<SVGSVGElement>>,
  RightArrow: IoChevronForward as React.FC<React.SVGProps<SVGSVGElement>>,
  BtnRigthArrow: FiArrowRight as React.FC<React.SVGProps<SVGSVGElement>>,
  MoviePlayerIcon: BiMoviePlay as React.FC<React.SVGProps<SVGSVGElement>>,
  WebsiteIcon: IoIosGlobe as React.FC<React.SVGProps<SVGSVGElement>>,
  PdfFileIcon: GrDocumentPdf as React.FC<React.SVGProps<SVGSVGElement>>,
  RefreshIcon: SlRefresh as React.FC<React.SVGProps<SVGSVGElement>>,
  calenderIcon: IoMdCalendar as React.FC<React.SVGProps<SVGSVGElement>>,
  FIlterIcon: CiFilter as React.FC<React.SVGProps<SVGSVGElement>>,
  SaveIcon: BiSave as React.FC<React.SVGProps<SVGSVGElement>>,
  BackIcon: IoArrowBack as React.FC<React.SVGProps<SVGSVGElement>>,
  CloseIcon: IoCloseOutline as React.FC<React.SVGProps<SVGSVGElement>>,
  CheckMark: IoMdCheckmarkCircleOutline as React.FC<
    React.SVGProps<SVGSVGElement>
  >,
};
